module.exports = __webpack_public_path__ + "static/media/profile2.0db4220c.jpg";